// extracted by mini-css-extract-plugin
export default {"post":"Post_post__zDSqq","tags":"Post_tags__3xqBr"};